import React, {
  useState,
  ReactNode,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

export interface Ref {
  handleShowModal: (show: boolean) => void;
}

interface Props {
  title: string;
  children: ReactNode;
  handleApply: () => void;
  width?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const Modal: ForwardRefRenderFunction<Ref, Props> = (
  { children, title, width = 'md', handleApply },
  ref
) => {
  const [open, setOpen] = useState(false);

  const handleShowModal = (show: boolean) => {
    setOpen(show);
  };

  useImperativeHandle(ref, () => ({
    handleShowModal,
  }));

  const handleClose = (event: any, reason: string) => {
    if (reason == 'backdropClick') {
      return;
    }
    handleShowModal(false);
  };

  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth={width}
      disableEscapeKeyDown
      onClose={handleClose}
      className="modal-container"
    >
      <DialogTitle className="modal-title">{title}</DialogTitle>
      <IconButton
        className="modal-close-btn"
        onClick={() => handleShowModal(false)}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions className="actions-container">
        <Button
          variant="contained"
          className="apply-btn"
          onClick={() => handleApply()}
        >
          Apply
        </Button>
        <Button
          variant="contained"
          className="close-btn"
          onClick={() => handleShowModal(false)}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default forwardRef<Ref, Props>(Modal);
